// @flow
// This file will replace the `general.js` once we get rid of the devices font icons

const weatherIcons = {
    BLACK_LOW_CLOUD: 'BLACK_LOW_CLOUD',
    CLEAR_SKY: 'CLEAR_SKY',
    CLOUDY_WITH_HEAVY_RAIN: 'CLOUDY_WITH_HEAVY_RAIN',
    CLOUDY_WITH_HEAVY_RAIN_NIGHT: 'CLOUDY_WITH_HEAVY_RAIN_NIGHT',
    CLOUDY_WITH_HEAVY_SNOW: 'CLOUDY_WITH_HEAVY_SNOW',
    CLOUDY_WITH_LIGHT_RAIN: 'CLOUDY_WITH_LIGHT_RAIN',
    CLOUDY_WITH_LIGHT_RAIN_NIGHT: 'CLOUDY_WITH_LIGHT_RAIN_NIGHT',
    CLOUDY_WITH_SLEET: 'CLOUDY_WITH_SLEET',
    FOG_MIST: 'FOG_MIST',
    HEAVY_RAIN_SHOWERS: 'HEAVY_RAIN_SHOWERS',
    HEAVY_SNOW_SHOWERS: 'HEAVY_SNOW_SHOWERS',
    HEAVY_SNOW_SHOWERS_NIGHT: 'HEAVY_SNOW_SHOWERS_NIGHT',
    LIGHT_RAIN_SHOWERS: 'LIGHT_RAIN_SHOWERS',
    LIGHT_SNOW: 'LIGHT_SNOW',
    LIGHT_SNOW_NIGHT: 'LIGHT_SNOW_NIGHT',
    LIGHT_SNOW_SHOWERS: 'LIGHT_SNOW_SHOWERS',
    SLEET_SHOWERS: 'SLEET_SHOWERS',
    SLEET_SHOWERS_NIGHT: 'SLEET_SHOWERS_NIGHT',
    SUNNY: 'SUNNY',
    SUNNY_INTERVALS: 'SUNNY_INTERVALS',
    SUNSET_SUNRISE: 'SUNSET_SUNRISE',
    THUNDER_SHOWERS: 'THUNDER_SHOWERS',
    THUNDER_SHOWERS_NIGHT: 'THUNDER_SHOWERS_NIGHT',
    THUNDERSTORMS: 'THUNDERSTORMS',
    WHITE_CLOUD: 'WHITE_CLOUD',
    WHITE_CLOUD_NIGHT: 'WHITE_CLOUD_NIGHT'
};

export default weatherIcons;
export type WeatherIcon = $Keys<typeof weatherIcons>;



// WEBPACK FOOTER //
// ./src/core/constants/icons/weather-svg.js